// extracted by mini-css-extract-plugin
export var contents = "style-module--contents--b7d50";
export var info = "style-module--info--7ee3a";
export var linkCard = "style-module--linkCard--e1223";
export var nullCard = "style-module--nullCard--0837a";
export var title = "style-module--title--f8cc7";
export var url = "style-module--url--2d4b7";